module.exports = __webpack_public_path__ + "img/T4-C-rc_0.d5bc7818.png";